/**
 * Removes all whitespace characters from an IBAN string
 * @param iban - The IBAN string with or without spaces
 * @returns The IBAN string without any spaces
 */
export function normalizeIban(iban: string | undefined): string | undefined {
	if (!iban) return iban
	return iban.replace(/\s/g, '')
}
